import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ExtractService {
  
  constructor() {}

  /**
   * Decodifica o payload de um JWT.
   * Retorna `null` para qualquer token inválido (formato, base64 ou JSON),
   * para que o chamador trate o caso sem quebrar o fluxo da aplicação.
   */
  getDecodedAccessToken(token: string): any {
    if (!token) {
      return null;
    }

    try {
      // JWT = header.payload.signature — sem o payload não há o que decodificar.
      const base64Url = token.split('.')[1];
      if (!base64Url) {
        return null;
      }

      const jsonPayload = this.decodeBase64Url(base64Url);

      return JSON.parse(jsonPayload);
    } catch (error) {
      console.warn('[ExtractService] Token inválido: não foi possível decodificar o payload.', error);
      return null;
    }
  }

  /** Converte base64url (RFC 7515) em texto UTF-8. */
  private decodeBase64Url(base64Url: string): string {
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');

    // O padding `=` é omitido no base64url, mas `atob` espera múltiplos de 4.
    const padding = (4 - (base64.length % 4)) % 4;
    const binary = atob(base64 + '='.repeat(padding));

    // TextDecoder interpreta os bytes como UTF-8 (preserva acentos do payload)
    // sem o encadeamento frágil de `decodeURIComponent`, que lança URIError.
    const bytes = Uint8Array.from(binary, char => char.charCodeAt(0));

    return new TextDecoder('utf-8').decode(bytes);
  }
}
